import Query from '../utils/Query';

export default class AuthService {

	static login(email, password) {

		return Query.post('/user/login', {
			email: email,
			password: password
		});
	}

	static register(email, password) {

		return Query.post('/user', {
			email: email,
			password: password
		});
	}
}
